<div [matMenuTriggerFor]="selfCheck ? selfMenu : publicMenu" class="pointer" *ngIf="showContextMenuCheck">
    <i class="icon-three-vertical-dots-fill font-md fx-contents"></i>
</div>
<mat-menu #selfMenu="matMenu">
    <button mat-menu-item (click)="goToProject()">
        <h4 class="margin-0 font-regular sparro-grey-900">Edit</h4>
    </button>
    <button mat-menu-item (click)="deleteProject()">
        <h4 class="margin-0 font-regular sparro-grey-900">Delete</h4>
    </button>
    <!--
    <button mat-menu-item (click)="togglePrivate()" *ngIf="projectCheck?.content?.published">
        <h4 class="margin-0 font-regular sparro-grey-900">{{ projectCheck.private ? 'Make public' : 'Make private'}}</h4>
    </button>
    -->
</mat-menu>

<mat-menu #publicMenu="matMenu">
    <button mat-menu-item *ngIf="projectCheck?.content?.published" (click)="toggleFollow()">
        <h4 class="margin-0 font-regular sparro-grey-900">
        {{ projectCheck.is_following ? 'Following' : 'Follow' }}
        </h4>
    </button>
    <button mat-menu-item *ngIf="projectCheck?.content?.published" (click)="openShareDialog()">
        <h4 class="margin-0 font-regular sparro-grey-900">Share</h4>
    </button>
    <button mat-menu-item *ngIf="!projectCheck.report || projectCheck.report?.status !== 'INITIATED' && projectCheck?.content?.published"
        [disabled]="projectCheck.report?.status === 'VERIFIED'"  (click)="createReport()">
        <h4 class="margin-0 font-regular sparro-grey-900">{{ projectCheck.report?.status === 'VERIFIED' ? 'Reported' : 'Report' }}
        </h4>
    </button>
    <button mat-menu-item *ngIf="projectCheck.report?.status === 'INITIATED'" (click)="redactReport()">
        <h4 class="margin-0 font-regular sparro-grey-900">Redact</h4>
    </button>
</mat-menu>
